module.exports = __webpack_public_path__ + "img/logo_without.9e94994d.svg";